/**
 * Entry point for all public APIs of the package.
 */
export * from './src/ngx-soundmanager2';

// This file only reexports content of the `src` folder. Keep it that way.
